<template>
  <div class='layout'>
    <el-container>
      <!--      &lt;!&ndash; 头部 &ndash;&gt;-->
      <!--      <layout-header v-if="route.meta.isShowHeader" @breadcrumbClick="breadcrumbClick"></layout-header>-->
      <!--      &lt;!&ndash; 左侧导航栏 &ndash;&gt;-->
      <!--      <layout-left v-if="route.meta.isShowLeftSider" ref="layoutLeft"></layout-left>-->
      <!-- 主体区域 -->
      <!--      <el-main :style="{ marginLeft: layoutMarginLeft + 'px', marginTop: LayoutHeaderHeight + 'px', padding: 0 }">-->
      <!--      <el-main>-->
      <!--        <transition name='fade-transform'>-->
      <!--          <keep-alive>-->
      <!--            <router-view-->
      <!--              v-if='route.meta.keepAlive'-->
      <!--              :style="{-->
      <!--                zIndex: 0,-->
      <!--                width: viewWidth + 'px',-->
      <!--                height: viewHeight + 'px',-->
      <!--                backgroundColor: 'rgba(255, 255, 255, 1)',-->
      <!--              }"-->
      <!--            ></router-view>-->
      <!--          </keep-alive>-->
      <!--        </transition>-->
      <transition name='fade-transform'>
        <router-view
          :style="{
              zIndex: 0,
              width: viewWidth + 'px',
              height: viewHeight + 'px',
              backgroundColor: 'rgba(255, 255, 255, 1)',
            }"
        ></router-view>
        <!--          <router-view-->
        <!--            v-if='!route.meta.keepAlive'-->
        <!--            :style="{-->
        <!--              zIndex: 0,-->
        <!--              width: viewWidth + 'px',-->
        <!--              height: viewHeight + 'px',-->
        <!--              backgroundColor: 'rgba(255, 255, 255, 1)',-->
        <!--            }"-->
        <!--          ></router-view>-->
      </transition>
      <!--      </el-main>-->
    </el-container>
  </div>
</template>

<script>
import LayoutLeft from './layout-left.vue'
import LayoutHeader from './layout-header.vue'

export default {
  name: 'layout',
  components: {
    LayoutHeader,
    LayoutLeft
  },
  data() {
    return {
      LayoutHeaderHeight: 50, // 50
      layoutMarginLeft: 200,
      viewWidth: 0,
      viewHeight: 0,
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      active: ''
    }
  },
  created() {
    // watch window size change
    window.addEventListener(
      'resize',
      () => {
        this.windowWidth = window.innerWidth
        this.windowHeight = window.innerHeight
      },
      false
    )
    this.computedStyle()
  },
  watch: {
    windowWidth(val) {
      this.computedStyle()
    },
    windowHeight(val) {
      this.computedStyle()
    },
    route(val) {
      this.computedStyle()
    }
  },
  methods: {
    breadcrumbClick() {
      this.$refs.layoutLeft.activePath = '0-0'
      window.sessionStorage.setItem('activePath', '0-0')
    },
    computedStyle() {
      let route = this.route
      let meta = route.meta
      let windowWidth = this.windowWidth
      let windowHeight = this.windowHeight
      if (meta.isShowLeftSider) {
        this.layoutMarginLeft = 200
        // this.viewWidth = windowWidth - this.layoutMarginLeft
        this.viewWidth = windowWidth
      } else {
        this.layoutMarginLeft = 0
        this.viewWidth = windowWidth
      }
      if (meta.isShowHeader) {
        // iview fix header heiget 64px
        this.LayoutHeaderHeight = 48
        // this.viewHeight = windowHeight - this.LayoutHeaderHeight
        this.viewHeight = windowHeight
      } else {
        this.LayoutHeaderHeight = 0
        this.viewHeight = windowHeight
      }
    },
    handleRefresh() {
      window.location.reload()
    }
  },
  computed: {
    path() {
      return this.$route.path
    },
    route() {
      // console.log(this.$route.meta);
      return this.$route
    },
    user() {
      return this.$store.state.user
    }
  }
}
</script>

<style scoped>
.el-main {
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/framework/layout/layout.vue